module.exports = __webpack_public_path__ + "img/Icon_home _free.3cea78e9.svg";